import HeadingWithTooltip from './HeadingWithTooltip.js';

export default HeadingWithTooltip;
